import * as React from "react";
import {cx} from "emotion";

import "./payment.scss";

import {ForceSticky}     from "@Common/react/browser/force-sticky";
import {cs}              from "@Common/react/chain-services";
import {formatMoney1}    from "@Common/ui-components/language/format-money";
import {toJsDate}        from "@Common/utils/date-object";
import {parseDateFormat} from "@Common/utils/date/parse-date-format";

import {groupEnrollmentEditors} from "../../common/group-enrollment-editors";
import {AgreeResponsibility}    from "../shared-components/agree-responsibility/agree-responsibility";

import {ScCreditCards}  from "./credit-cards/sc-credit-cards";
import {PaymentDetails} from "./payment-details/payment-details";

export const Payment = (
    {
        initEnrollment, program, agentId,
        upcomingEdition,
        estimatedTotal,
        next,
    }
) => cs(
    ["creditCards", ({}, next) => ScCreditCards({
        initEnrollment, agentId,
        required: program.programPreferences.requireCreditCard,
        next,
    })],
    ["paymentDetails", ({creditCards}, next) => PaymentDetails({
        required: !program.programPreferences.requireCreditCard && !creditCards.fulfilled,
        initEnrollment,
        program,
        next,
    })],

    ["agreeResponsibility", (_, next) => !initEnrollment?.enrolled ? (
        AgreeResponsibility({next})
    ) : (
        next(null)
    )],

    ({creditCards, paymentDetails, agreeResponsibility}) => next({
        enrollmentEditor: groupEnrollmentEditors([
            creditCards.enrollmentEditor,
            paymentDetails.enrollmentEditor,
            agreeResponsibility?.enrollmentEditor,
        ].filter(v=>v)),

        render: ({showErrors, renderSummary}) => cs(
            ["forceSticky", (_, next) => ForceSticky({next})],
            ({forceSticky}) => (
                <div {...{
                    className: cx("payment-9k7"),

                    "xd-qa-type": "card",
                    "xd-qa-name": "Payment",
                }}>
                    <div className="left">
                        {paymentDetails.render({showErrors})}

                        {creditCards.render({showErrors})}
                    </div>

                    <div className="right">
                        <div className="sticky" ref={forceSticky.domRef}>
                            {renderSummary({})}

                            <div {...{
                                className: "last-message",

                                "xd-qa-type": "text",
                                "xd-qa-name": "Last message",
                            }}>
                                {
                                    `Your direct mail campaign is ready! After you complete enrollment, you'll have until ` +
                                    (!upcomingEdition ? "--" : toJsDate(parseDate(upcomingEdition.orderReviewDeadline)).toLocaleDateString()) + " " +
                                    `to make changes to your personal information or payment preferences, `+
                                    `before we begin production and process the payment of ` +
                                    formatMoney1(estimatedTotal) + " " +
                                    `for this edition.`
                                }
                            </div>

                            {agreeResponsibility?.render()}
                        </div>
                    </div>
                </div>
            ),
        ),
    }),
);

const parseDate = (str):any => parseDateFormat("yyyy-mm-dd").parseDate(str);
